import type { FC, SVGProps } from 'react';

const HornIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 8.0004V12.0004M10.25 5.5004H6.8C5.11984 5.5004 4.27976 5.5004 3.63803 5.82738C3.07354 6.115 2.6146 6.57394 2.32698 7.13843C2 7.78016 2 8.62024 2 10.3004L2 11.5004C2 12.4323 2 12.8982 2.15224 13.2658C2.35523 13.7558 2.74458 14.1452 3.23463 14.3482C3.60218 14.5004 4.06812 14.5004 5 14.5004V18.7504C5 18.9826 5 19.0987 5.00963 19.1964C5.10316 20.146 5.85441 20.8972 6.80397 20.9908C6.90175 21.0004 7.01783 21.0004 7.25 21.0004C7.48217 21.0004 7.59826 21.0004 7.69604 20.9908C8.64559 20.8972 9.39685 20.146 9.49037 19.1964C9.5 19.0987 9.5 18.9826 9.5 18.7504V14.5004H10.25C12.0164 14.5004 14.1772 15.4473 15.8443 16.356C16.8168 16.8862 17.3031 17.1513 17.6216 17.1123C17.9169 17.0761 18.1402 16.9435 18.3133 16.7015C18.5 16.4405 18.5 15.9184 18.5 14.8741V5.12668C18.5 4.0824 18.5 3.56025 18.3133 3.29929C18.1402 3.0573 17.9169 2.9247 17.6216 2.88853C17.3031 2.84952 16.8168 3.1146 15.8443 3.64475C14.1772 4.55351 12.0164 5.5004 10.25 5.5004Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HornIcon;
